import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white mt-16">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <div className="h-8 w-8 rounded-lg bg-slate-900 flex items-center justify-center">
                <ShieldCheck size={18} className="text-emerald-400" />
              </div>
              <span className="font-display text-xl text-slate-900" style={{ fontWeight: 800 }}>
                my360<span className="text-emerald-600">boss</span>
              </span>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              The honest, anonymous read on your boss. Real feedback from real teams — rated on leadership and management.
            </p>
          </div>

          <div className="flex gap-12">
            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-slate-400 mb-3">Explore</p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li><Link to="/supervisors" className="hover:text-emerald-700" data-testid="footer-browse-link">Browse supervisors</Link></li>
                <li><Link to="/companies" className="hover:text-emerald-700">Companies</Link></li>
                <li><Link to="/compare" className="hover:text-emerald-700">Compare</Link></li>
                <li><Link to="/analytics" className="hover:text-emerald-700">Analytics</Link></li>
                <li><Link to="/for-employers" className="hover:text-emerald-700" data-testid="footer-employers-link">For Employers</Link></li>
                <li><Link to="/pricing" className="hover:text-emerald-700" data-testid="footer-pricing-link">Pricing</Link></li>
                <li><Link to="/insights" className="hover:text-emerald-700" data-testid="footer-insights-link">Insights</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-slate-400 mb-3">Trust</p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li><Link to="/faq" className="hover:text-emerald-700" data-testid="footer-faq-link">FAQs</Link></li>
                <li><Link to="/disclaimer" className="hover:text-emerald-700" data-testid="footer-disclaimer-link">Disclaimer</Link></li>
                <li><Link to="/terms" className="hover:text-emerald-700" data-testid="footer-terms-link">Terms of Service</Link></li>
                <li><Link to="/privacy" className="hover:text-emerald-700" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-100 mt-8 pt-6">
          <p className="text-xs text-slate-400 leading-relaxed">
            <b className="text-slate-500">Disclaimer:</b> All ratings, reviews, and comments on my360boss are the personal opinions of individual users and do not reflect the views of my360boss. my360boss does not verify content and waives all liability for any content posted about supervisors. Users are solely responsible for what they post. See our{" "}
            <Link to="/disclaimer" className="text-emerald-700 underline">full disclaimer</Link>.
          </p>
          <p className="text-xs text-slate-400 mt-3">© {new Date().getFullYear()} my360boss. All opinions belong to their authors.</p>
        </div>
      </div>
    </footer>
  );
}
